export const INVALID_SESSION = 'INVALID_SESSION';